/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

const ChevronDown = ({
  className,
  width = "25",
  height = "24",
}: {
  className?: string;
  width?: string | number;
  height?: string | number;
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M15 12.7002L10 7.7002L5 12.7002"
        stroke="currentColor"
        stroke-width="2"
      />
    </svg>
  );
};

export default ChevronDown;
